import { cn } from '../lib/utils';
import { NessoSpinner } from '../primitives/nesso-spinner';

type Props = {
    className?: string;
    label?: string;
};

export function LoadingPage({ className, label }: Props) {
    return (
        <div
            className={cn(
                'h-dvh w-full flex flex-col items-center justify-center gap-6 bg-background',
                className,
            )}
        >
            <NessoSpinner label={label} />
            {label ? <p className="text-base text-muted-foreground">{label}</p> : null}
        </div>
    );
}
